import commonHelper from '@/app/utility/common.helper.utility';
import Event from '../../workflowEvent';
import user from '../../../admin/user';
export default {
  name: 'updateWorkflowDelegation',
  watch: {
    // currentPage: function() {
    // },
    // perPage: function() {
    //   this.currentPage = 1;
    // },
    searchEventName: function() {
      if (this.searchEventName && this.searchEventName.length >= 0) {
        if (this.updateWorkflowDelegationData.length > 0) {
          this.updateWorkflowDelegationData = this.filteredEventList(); 
        } else {
          this.$bvToast.toast('Kindly search data first', {
            title: 'Alert',
            variant: 'danger',
            solid: true
          });
        }
      } else {
        this.updateWorkflowDelegationData = this.currentNotificationDetailsList;
      }
    }
  },
  components: {
    Event,
    user
  },
  data() {
    return {
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      perPageVendor: commonHelper.perPageRecord,
      loader: false,
      showValueSetModal: false,
      eventType: null,
      vendor: null,
      invoiceNum: null,
      fromUser: null,
      toUser: null,
      updateWorkflowDelegationData: [],
      updateWorkflowDelegationFields: [],
      updateWorkflowToDelegateData: [],
      updateWorkflowToDelegateFields: [],
      currentNotificationDetailsList: [],
      selectAllCheckBox: false,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: true,
        addAllow: true,
        printAllow: false,
        approvalAllow: false
      },
      showEmployeeModal: false,
      eventId: null,
      showHideUserDetailsModalFlag: false,
      fromUserId: null,
      toUserId: null,
      searchEventName: null,
      userTypeData: {
        value: 'EMP',
        text: 'Employee'
      },
      typeUser: null,
      totalRows1: null,
      responseMsg: null,
      showAlert: false,
      isSuccess: false
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          if (this.eventId && this.fromUserId && this.toUserId) {
            this.postDelegationInvoice();
          } else {
            this.$bvToast.toast('Kindly select mandatory fields', {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        }
      }
    });
  },
  methods: {
    showHideEmpModal(flag) {
      this.showEmployeeModal = flag;
    },
    selectedEmployee(item) {
      this.eventType = item.event_name;
      this.eventId = item.event_id;
      this.showEmployeeModal = false;
    },
    getDataEvents(user) {
      if (user) {
        this.getEvents();
      } else {
        this.$bvToast.toast('Kindly select mandatory fields', {
          title: 'Alert',
          variant: 'danger',
          solid: true
        });
      }
    },
    // 1.1 change in the get api for invoiceapproval
    getEvents() {
      const payload = {
        status: 'INPROCESS',
        eventId: this.eventId,
        userId: this.fromUserId
      };
      this.loader = true;
      this.$store
        // .dispatch('intWorkflow/getNotificationDetailByUserId', payload)
        .dispatch('intWorkflow/getDelegationInvoiceByUserId', payload) // Gourav 1.1 change in get api
        .then(response => {
          this.loader = false;
          if (response.status === 200 && response.data.data.data.length >= 0) {
            this.updateWorkflowDelegationFields = [
              {
                key: 'selectBox',
                label: 'Select All',
                stickyColumn: true,
                variant: 'info'
              }
            ];
            const columnsField = response.data.data.columns;
            columnsField.forEach(index => {
              this.updateWorkflowDelegationFields.push({
                key: index.name,
                label: index.display_name,
                class: index.display ? '' : 'd-none'
              });
              this.updateWorkflowToDelegateFields.push({
                key: index.name,
                label: index.display_name,
                class: index.display ? '' : 'd-none'
              });
            });
            this.currentNotificationDetailsList = response.data.data.data;
            this.updateWorkflowDelegationData = response.data.data.data;
            this.totalRows = this.updateWorkflowDelegationData.length;
            if (this.updateWorkflowToDelegateData.length) {
              this.updateWorkflowToDelegateData = [];
              this.totalRows1 = null;
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    selectBoxChecked(event, item, vendorInvId) {
      // this.updateWorkflowToDelegateData = this.updateWorkflowDelegationData.filter(
      //   ele => ele.selectBox == true
      // );
      if (event === true) {
        this.totalRows1++;
        this.updateWorkflowToDelegateData.push(item);
      } else {
        this.totalRows1--;
        this.updateWorkflowToDelegateData = this.updateWorkflowToDelegateData.filter((item) => item.vendor_inv_id !== vendorInvId)
      }
    },
    selectAllBoxChecked(flag) {
      this.updateWorkflowDelegationData.forEach(ele => {
        this.$set(ele, 'selectBox', flag);
      });
      this.updateWorkflowToDelegateData = this.updateWorkflowDelegationData.filter(
        ele => ele.selectBox == true
      );
      if (flag === true) {
        this.totalRows1 = this.totalRows;
      } else {
        this.totalRows1 = 0;
      }
    },
    showHideUserDetailsModal(flag, item) {
      if (flag) {
        this.typeUser = item;
      }
      if (this.eventType) {
        this.showHideUserDetailsModalFlag = flag;
        if (!flag && item) {
          if (this.typeUser == 'fromUser') {
            this.fromUserId = item.user_ref_id;
            this.fromUser = item.name;
          } else if (this.typeUser == 'toUser') {
            this.toUserId = item.user_ref_id;
            this.toUser = item.name;
          }
          if (this.fromUserId === this.toUserId) {
            this.$bvToast.toast(
              'Kindly select different user for delegation ',
              {
                title: 'Alert',
                variant: 'danger',
                solid: true
              }
            );
            this.toUser = null;
          }
        }
      } else {
        this.$bvToast.toast('Kindly select event first', {
          title: 'Alert',
          variant: 'danger',
          solid: true
        });
      }
    },
    clearVsetValues(data) {
      if (data == 'fromUser') {
        this.fromUser = null;
        this.fromUserId = null;
        this.updateWorkflowDelegationData = [];
        this.currentNotificationDetailsList = [];
        this.totalRows = null;
      } else if (data == 'toUser') {
        this.toUserId = null;
        this.toUser = null;
      }
    },
    filteredEventList() {
      if (!this.searchEventName) {
      return this.currentNotificationDetailsList;
      }
      this.searchEventName = this.searchEventName.replace(/\s+/g, ' ').trim().toLowerCase();
       return this.currentNotificationDetailsList.filter(product => {
    for (let prop in product) {
      if (
        product[prop] !== null &&
        product[prop] !== undefined &&
        product[prop].toString().toLowerCase().includes(this.searchEventName)
      ) {
        return true;
      }
    }
    return false;
  });
      // if (undefined === this.searchEventName || this.searchEventName === '')
      //    return this.currentNotificationDetailsList;
      // return this.currentNotificationDetailsList.filter(product => {
      //   let flag;
      //   for (let prop in product) {          
      //     flag = false;
      //     flag = product[prop].toString().indexOf(this.searchEventName) > -1;
      //     if (flag) break;
      //   }
      //   return flag;
      // });
    },
    postDelegationInvoice() {
      const delegatedInvoice = this.updateWorkflowToDelegateData.map(data =>
        Number(data.vendor_inv_id)
      );
      const payload = {
        delegated_from: this.fromUserId,
        event_id: this.eventId,
        delegated_to: this.toUserId,
        delegation_invoices: delegatedInvoice
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/postDelegationInvoice', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.updateWorkflowToDelegateData = [];
            this.totalRows1 = null;
            this.getEvents();
            this.showAlert = true;
            this.isSuccess = true;
            this.responseMsg = response.data.data;
            this.$bvToast.toast(response.data.message, {
              title: 'Alert',
              variant: 'success',
              solid: true
            });
          } else {
            this.loader = false;
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg = response.response.data.data;
            this.$bvToast.toast(response.response.data.message, {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch(err => {
          this.err = err;
          this.loader = false;
        });
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
